import { render } from "./demo-day-investor-application-review.vue?vue&type=template&id=6b934fd7"
import script from "./demo-day-investor-application-review.vue?vue&type=script&lang=js"
export * from "./demo-day-investor-application-review.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__